<template>
  <!-- Error Message -->
  <PageError v-if="error"
   :error="error"
   :errorCode="errorCode" 
  />

  <div class="p-6" v-if="fortigate">
    <h1 class="text-2xl font-semibold mb-6 flex dark:text-white">
      <button
        @click="goBack"
        class="mr-4 bg-blue-600 text-white px-4 py-1.5 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200 text-sm font-medium flex items-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 mr-1"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
            clip-rule="evenodd"
          />
        </svg>
        Back to Fortigates
      </button>
     Fortigate Details: {{ fortigate.job_name }}
      <div class="relative group">
      <button
        type="button"
        class="hover:bg-transparent bg-transparent ml-2"
        @click="startTutorial"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-question-mark dark:text-gray-50 text-gray-900"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>
      </button>
        <span class="absolute top-full text-xs right-1/2 -translate-y-1/2 glass-card mb-1 px-1.5 py-0.5 text-xs text-white bg-gray-800 dark:bg-gray-700 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap">Tutorial</span>
      </div>
    </h1>
    <!-- Table Header -->
    <div class="overflow-hidden rounded-xl backdrop-blur-md bg-white/80 dark:bg-slate-900/60">
    <table class="w-full text-left">
      <thead class="text-white bg-gradient-to-r from-slate-900/95 to-slate-800/95 dark:from-slate-900/95 dark:to-slate-800/95 backdrop-blur-md border-b border-slate-700/50 dark:border-slate-700/50">
        <tr>
          <th class="py-2 px-4 w-1/3">Field</th>
          <th class="py-2 px-4 w-2/3">Value</th>
        </tr>
      </thead>
      <tbody class="divide-y dark:divide-gray-600/60">
        <tr
          v-for="(field, index) in visibleFields"
          :key="field.key"
          :id="'fortigate-field-' + field.key"
          class="hover:bg-gray-900/30 transition-colors"
        >
          <td class="py-4 px-4">{{ field.label }}</td>
          <td class="py-4 px-4">
            <template v-if="editingField === field.key">
              <div class="flex items-start gap-2 w-full">
                <input 
                  v-if="field.key!=='site'"
                  v-model="editValue"
                  :type="field.type"
                  class="border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"

                />
                <GlassSelect
                  v-else-if="field.key == 'site'"
                  v-model="editValue"
                  :options="sites"
                  placeholder="Select a site"
                  :valueKey="'id'"
                  :labelKey="'name'"
                />

                <!-- General Save and Edit Buttons -->
                <div class="flex space-x-2">
                  <button
                    @click="saveEdit(field.key)"
                    class="ml-2 bg-green-600 text-white btn hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 transition duration-200"
                  >
                    Save
                  </button>
                  <button
                    @click="cancelEdit"
                    class="ml-2 bg-red-600 text-white btn hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition duration-200"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </template>

            
            <template v-else>
              <!-- Display Field Data -->
              <div class="flex">
              
              <span class="flex-grow">{{ formatValue(field.key, fortigate[field.key]) }}</span>
    
              <!-- Handle Editing -->
              <div class="relative w-1/2">
                  <button 
                    v-if="handleNoEdit(field.key)"
                    @click="startEdit(field.key)"
                    @mouseover="showToolTip=true, hoveritem=field.key"
                    @mouseleave="showToolTip=false"
                    :id=field.key
                    class="ml-2 p-1 ml-10 text-gray-400 hover:text-blue-500 dark:text-blue-500 transition-colors duration-150"
                  >
                    <svg
                      class="h-4 w-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                      />
                    </svg>
                  </button>
                  <span 
                    v-if="showToolTip && hoveritem === field.key"
                    class="absolute bottom-full whitespace-nowrap mb-2 transform -translate-x-1/2 rounded py-1 px-2  dark:shadow-lg dark:bg-gray-500 bg-gray-800 bg-gray-800 text-white text-center "
                      >
                      {{ field.key == 'targets' ? 'Add '  : 'Change ' }}{{field.label}}
                  </span>
              </div>
              </div>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
  <div v-else>
    <p>Loading...</p>
  </div>
</template>

<script>
import { getFortigateById, updateFortigate } from "@/services/fortigateService";
import { getSites } from "@/services/siteService";
import { useStore } from "@/store";
import FieldError from "@/components/FieldError.vue";
import { useMultiTenant } from "@/composables/useMultiTenant";
import PageError from "@/components/PageError.vue";
import GlassSelect from "@/components/GlassSelect.vue";
import { useTutorial } from "@/composables/tutorial";

export default {
  components : {
    FieldError,
    PageError,
    GlassSelect,
  },
  data() {
    return {
      fieldErrors: {},
      fortigate: null,
      showToolTip: false,
      editingField: null,
      editValue: null,
      targets : [],
      targetAdded : false,
      addingTarget: false,
      lastTarget: false,
      selectedTarget: null,
      showTargets: false,
      deletingTarget : false,
      sites: [],
      noEditFields: ['job_name', 'last_modified', 'created_date','fortigate_endpoint'],
      displayFields: [
        { key: "job_name", label: "Job Name", type: "text" },
        { key: "fortigate_endpoint", label: "Fortigate", type: "text" },
        { key: "token", label: "Token", type: "text" },
        { key: "scrape_interval", label: "Scrape Interval", type: "number", staffOnly: true },
        { key: "scrape_timeout", label: "Scrape Timeout", type: "number", staffOnly: true },
        { key: "site", label: "Site", type: "text" },
      ],
      canChangeFortigate: true,
      fortigateDetailSteps: [
        {
          element: '#fortigate-field-job_name',
          action: 'display',
          message: 'The job name uniquely identifies this Fortigate.'
        },
        {
          element: '#fortigate-field-token',
          action: 'display',
          message: 'The API token used to authenticate. Click the pencil icon to edit.'
        },
        {
          element: '#fortigate-field-scrape_interval',
          action: 'display',
          message: 'How often (in seconds) metrics are scraped. Click the pencil icon to edit.'
        },
        {
          element: '#fortigate-field-scrape_timeout',
          action: 'display',
          message: 'Timeout in seconds for each scrape. Click the pencil icon to edit.'
        },
        {
          element: '#fortigate-field-site',
          action: 'display',
          message: 'The site this Fortigate is associated with. Click the pencil icon to edit.'
        },
      ],
    };
  },
  setup(){
    const tenant = useMultiTenant();
    const { start } = useTutorial();
    return { tenant, _start: start };
  },
  computed: {
    user(){
      return useStore.getUser();
    },
    visibleFields() {
      return this.displayFields.filter(f => !f.staffOnly || useStore.isStaff());
    }
  },
  async beforeMount(){
    try {
      const validation = this.tenant.validateSchemaForOperation();
      this.sites = await getSites(validation.schemaName);
    } catch (error) {
      console.error("Error fetching sites:", error);
    }
  },
  async mounted() {
    const fortigateId = this.$route.params.id;
    try {
      const validation = this.tenant.validateSchemaForOperation();
      if (!validation.valid) {
        this.error = "Malformed request. Failed to get fortigate details!";
        this.errorCode = "422!";
        return;
      }
      this.fortigate = await getFortigateById(fortigateId, validation.schemaName);
     
      if (this.user) {
        this.canChangeFortigate = await useStore.hasPermission("Can change fortigate");
      }
    } catch (error) {
      console.error("Error fetching fortigate:", error);
    }
  },
  methods: {
    async startTutorial() {
      await this._start(this.fortigateDetailSteps);
    },
    goBack(){
      this.$router.push({
        name: 'Fortigates',
        query: this.tenant.addSchemaParam()
      });
    },
    startEdit(key) {
      this.editingField = key;
      this.editValue = this.fortigate[key];
      this.showToolTip = false
    },
    cancelEdit() {
      this.editingField = null;
      this.editValue = null;
      this.fieldErrors = {};
    },
    async saveEdit(key) {
      try {
        const validation = this.tenant.validateSchemaForOperation();
        if (!validation.valid) {
          this.error = "Malformed request. Failed to update fortigate!";
          this.errorCode = "422!";
          return;
        }
        this.fieldErrors = {};

        this.fortigate[key] = this.editValue;
        this.editValue = null;
        const updatedFortigate = await updateFortigate(
          this.fortigate.id,
          this.fortigate,
          validation.schemaName
        );
        this.fortigate = { ...this.fortigate, ...updatedFortigate };
        this.editingField = null;
        this.editValue = null;
        this.targets = [];
        this.addingTarget = false;
        this.deletingTarget = false;

      } catch (error) {
        this.fieldErrors = {}
        const items = this.displayFields;
        const errData = error?.response?.data;

        items.forEach(element => {
          const fieldError = errData?.[element.key];
          if (fieldError?.[0]) {
            this.fieldErrors[element.key] = fieldError[0]; 
          }
        });
        console.error("Error updating fortigate:", error);
      }
    },
    formatValue(key, value) {  
      if (key === 'site'){
        const displayValue = this.sites.find(item => item.id === value)
        return displayValue? displayValue["name"] : "redacted"
      }
      return value !== null && value !== undefined ? value : "N/A";
    },
    handleNoEdit(key) {
      if (this.canChangeFortigate || this.user?.is_staff){
        return !this.noEditFields.includes(key);
      }
    },
  },
};
</script>